<template>
  <section class="container form-container">
    <form class="card table-list">
      <h3>{{$t('VerifyPublishTitle')}}</h3>
      <label>{{$t('EnterContractAddress')}}</label>
      <input type="text" v-model="address" placeholder="0x" @keydown.enter.prevent>
      <!-- <label>{{$t('SelectCompilerType')}}</label>
      <select :class="{selected:type}" name="type" v-model="type">
        <option value="" disabled selected>{{$t('PleaseSelect')}}</option>
        <option value="1">Solidity (Single file)</option>
        <option value="2">Solidity (Multi-Part files)</option>
        <option value="3">Solidity (Standard-Json-Input)</option>
        <option value="4">Vyper (Experimental)</option>
      </select> -->
      <label>{{$t('SelectCompilerVersion')}}</label>
      <select :class="{selected:version}" name="version" v-model="version">
        <option value="" disabled selected>{{$t('PleaseSelect')}}</option>
        <option v-for="(item,i) in cv" :value="item" :key="i">{{item}}</option>
      </select>
      <label>Optimization</label>
      <select :class="{selected:optimization}" name="optimization" v-model="optimization">
        <option value="" disabled selected>{{$t('PleaseSelect')}}</option>
        <option value="1">Yes</option>
        <option value="0">No</option>
      </select>
      <!-- <label>{{$t('SelectLicenseType')}}</label>
      <select :class="{selected: licenseType}" name="licenseType" v-model="licenseType">
        <option value="" disabled selected>{{$t('PleaseSelect')}}</option>
        <option value="1">1) No License (None)</option>
        <option value="2">2) The Unlicense (Unlicense)</option>
        <option value="3">3) MIT License (MIT)</option>
        <option value="4">4) GNU General Public License v2.0 (GNU GPLv2)</option>
        <option value="5">5) GNU General Public License v3.0 (GNU GPLv3)</option>
        <option value="6">6) GNU Lesser General Public License v2.1 (GNU LGPLv2.1)</option>
        <option value="7">7) GNU Lesser General Public License v3.0 (GNU LGPLv3)</option>
        <option value="8">8) BSD 2-clause "Simplified" license (BSD-2-Clause)</option>
        <option value="9">9) BSD 3-clause "New" Or "Revised" license (BSD-3-Clause)</option>
        <option value="10">10) Mozilla Public License 2.0 (MPL-2.0)</option>
        <option value="11">11) Open Software License 3.0 (OSL-3.0)</option>
        <option value="12">12) Apache 2.0 (Apache-2.0)</option>
        <option value="13">13) GNU Affero General Public License (GNU AGPLv3)</option>
      </select> -->
      <label>{{$t('EnterSolidityCode')}}</label>
      <textarea name="code" v-model="code" cols="30" rows="20"></textarea>
      <p class="text-center">
        <button @click.prevent="publish">{{$t('VerifyPublish')}}</button>
      </p>
    </form>
    <Loading :loading="loading"/>
  </section>
</template>
<script>
import Loading from "base/loading";
export default {
  props:['contract'],
  components:{Loading},
  data(){
    return {
      version:'',
      code:'',
      address:this.contract,
      loading:false,
      optimization:'',
      cv:["v0.8.6+commit.11564f7e","v0.8.5+commit.a4f2e591","v0.8.4+commit.c7e474f2","v0.8.3+commit.8d00100c","v0.8.2+commit.661d1103","v0.8.1+commit.df193b15","v0.8.0+commit.c7dfd78e","v0.7.6+commit.7338295f","v0.7.5+commit.eb77ed08","v0.7.4+commit.3f05b770","v0.7.3+commit.9bfce1f6","v0.7.2+commit.51b20bc0","v0.7.1+commit.f4a555be","v0.7.0+commit.9e61f92b","v0.6.9+commit.3e3065ac","v0.6.8+commit.0bbfe453","v0.6.7+commit.b8d736ae","v0.6.6+commit.6c089d02","v0.6.5+commit.f956cc89","v0.6.4+commit.1dca32f3","v0.6.3+commit.8dda9521","v0.6.2+commit.bacdbe57","v0.6.12+commit.27d51765","v0.6.11+commit.5ef660b1","v0.6.10+commit.00c0fcaf","v0.6.1+commit.e6f7d5a4","v0.6.0+commit.26b70077","v0.5.9+commit.e560f70d","v0.5.8+commit.23d335f2","v0.5.7+commit.6da8b019","v0.5.6+commit.b259423e","v0.5.5+commit.47a71e8f","v0.5.4+commit.9549d8ff","v0.5.3+commit.10d17f24","v0.5.2+commit.1df8f40c","v0.5.16+commit.9c3226ce","v0.5.15+commit.6a57276f","v0.5.14+commit.01f1aaa4","v0.5.13+commit.5b0b510c","v0.5.12+commit.7709ece9","v0.5.11+commit.c082d0b4","v0.5.10+commit.5a6ea5b1","v0.5.1+commit.c8a2cb62","v0.5.0+commit.1d4f565a","v0.4.9+commit.364da425","v0.4.8+commit.60cc1668","v0.4.7+commit.822622cf","v0.4.6+commit.2dabbdf0","v0.4.5+commit.b318366e","v0.4.4+commit.4633f3de","v0.4.3+commit.2353da71","v0.4.26+commit.4563c3fc","v0.4.25+commit.59dbf8f1","v0.4.24+commit.e67f0147","v0.4.23+commit.124ca40d","v0.4.22+commit.4cb486ee","v0.4.21+commit.dfe3193c","v0.4.20+commit.3155dd80","v0.4.2+commit.af6afb04","v0.4.19+commit.c4cbbb05","v0.4.18+commit.9cf6e910","v0.4.17+commit.bdeb9e52","v0.4.16+commit.d7661dd9","v0.4.15+commit.bbb8e64f","v0.4.14+commit.c2215d46","v0.4.13+commit.0fb4cb1a","v0.4.12+commit.194ff033","v0.4.11+commit.68ef5810","v0.4.10+commit.f0d539ae","v0.4.1+commit.4fc6fc2c","v0.4.0+commit.acd334c9","v0.3.6+commit.3fc68da5"]
      // type:'1',
      // licenseType:'',
      // cvs:{
      //   solidity:["v0.8.6+commit.11564f7e","v0.8.5+commit.a4f2e591","v0.8.4+commit.c7e474f2","v0.8.3+commit.8d00100c","v0.8.2+commit.661d1103","v0.8.1+commit.df193b15","v0.8.0+commit.c7dfd78e","v0.7.6+commit.7338295f","v0.7.5+commit.eb77ed08","v0.7.4+commit.3f05b770","v0.7.3+commit.9bfce1f6","v0.7.2+commit.51b20bc0","v0.7.1+commit.f4a555be","v0.7.0+commit.9e61f92b","v0.6.12+commit.27d51765","v0.6.11+commit.5ef660b1","v0.6.10+commit.00c0fcaf","v0.6.9+commit.3e3065ac","v0.6.8+commit.0bbfe453","v0.6.7+commit.b8d736ae","v0.6.6+commit.6c089d02","v0.6.5+commit.f956cc89","v0.6.4+commit.1dca32f3","v0.6.3+commit.8dda9521","v0.6.2+commit.bacdbe57","v0.6.1+commit.e6f7d5a4","v0.6.0+commit.26b70077","v0.5.17+commit.d19bba13","v0.5.16+commit.9c3226ce","v0.5.15+commit.6a57276f","v0.5.14+commit.01f1aaa4","v0.5.13+commit.5b0b510c","v0.5.12+commit.7709ece9","v0.5.11+commit.22be8592","v0.5.11+commit.c082d0b4","v0.5.10+commit.5a6ea5b1","v0.5.9+commit.c68bc34e","v0.5.9+commit.e560f70d","v0.5.8+commit.23d335f2","v0.5.7+commit.6da8b019","v0.5.6+commit.b259423e","v0.5.5+commit.47a71e8f","v0.5.4+commit.9549d8ff","v0.5.3+commit.10d17f24","v0.5.2+commit.1df8f40c","v0.5.1+commit.c8a2cb62","v0.5.0+commit.1d4f565a","v0.4.26+commit.4563c3fc","v0.4.25+commit.59dbf8f1","v0.4.24+commit.e67f0147","v0.4.23+commit.124ca40d","v0.4.22+commit.4cb486ee","v0.4.21+commit.dfe3193c","v0.4.20+commit.3155dd80","v0.4.19+commit.c4cbbb05","v0.4.18+commit.9cf6e910","v0.4.17+commit.bdeb9e52","v0.4.16+commit.d7661dd9","v0.4.15+commit.8b45bddb","v0.4.15+commit.bbb8e64f","v0.4.14+commit.c2215d46","v0.4.13+commit.0fb4cb1a","v0.4.12+commit.194ff033","v0.4.11+commit.68ef5810"],
      //   vyper:["vyper:0.2.12","vyper:0.2.11","vyper:0.2.8","vyper:0.2.7","vyper:0.2.5","vyper:0.2.4","vyper:0.2.3","vyper:0.2.2","vyper:0.2.1","vyper:0.2.0","vyper:0.1.0b17","vyper:0.1.0b16","vyper:0.1.0b15","vyper:0.1.0b14","vyper:0.1.0b13.hotfix","vyper:0.1.0b13","vyper:0.1.0b12","vyper:0.1.0b11","vyper:0.1.0b10","vyper:0.1.0b9","vyper:0.1.0b8","vyper:0.1.0b7","vyper:0.1.0b4"]
      // }
    }
  },
  watch:{
    contract(to){
      this.address = to;
    }
  },
  // computed:{
  //   cv(){
  //     if(this.cvs&&this.type){
  //       if(this.type==4){
  //         return this.cvs.vyper
  //       }
  //       return this.cvs.solidity;
  //     }
  //     return null;
  //   }
  // },
  methods:{
    publish(){
      if(!this.address){
        return this.$toast('EnterContractAddress')
      }
      if(!this.version){
        return this.$toast('SelectCompilerVersion')
      }
      if(!this.code){
        return this.$toast('EnterSolidityCode')
      }
      // if(!this.type){
      //   return this.$toast('SelectCompilerType')
      // }
      this.loading=true;
      let params = {
        "address": this.address.toLowerCase(),
        "version": this.version,
        "optimization": this.optimization-0,
        "code": window.btoa(this.code),
        "name": " ",
      }
      this.axios.post(this.domain+'evm/compiler',params).then(res=>{
        this.loading=false;
        if(res.data.code==0){
          this.$toast('Success').then(()=>{
            this.$router.push('/evm/'+this.address)
          })
        }else{
          this.$toast(res.data.message)
        }
      }).catch(err=>{
        console.log(err);
        this.loading=false;
      })
    }
  }
}
</script>